module.exports = "<div class=\"kl-col kl-col-{span} kl-col-offset-{offset} {class}\" gutter=\"{gutter}\" mediaSize>\n  {#inc this.$body}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLRow/KLCol/index.html
// module id = 555
// module chunks = 0